import React from 'react';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { ContentSpacer } from '../../../../global/components/layout/generic-content-spacer';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { GroupAdminAddFormValues } from '../../../arc/features/groups/admin/group-admin-add-form-model';
import { OfficerAddFormValues } from '../../../arc/features/institution-officers/officer-add-form-model';
import { DependentFormValues } from '../../features/dependents/dependent-form-models';
import { MaritalStatusFormValues } from '../../features/marital-status/marital-form-models';
import { PhoneFields } from '../../models/form-models';
import { formatFormatedPhoneNumber } from '../../../../global/helpers/form-data-helper';

interface ContentProps {
    values: MaritalStatusFormValues | DependentFormValues | GroupAdminAddFormValues | OfficerAddFormValues | PhoneFields;
    labelSetting: LabelSettingProps;
}

export function PhonesContentDisplay(props: ContentProps) {
    const { values, labelSetting } = props;

    if (!values.business_phone_formated && !values.home_phone_formated && !values.mobile_phone_formated) return null;

    return (
        <>
            {values.business_phone_formated && <LabelAndValue label={labelSetting.businessPhoneLabel} value={formatFormatedPhoneNumber(values.business_phone_formated)} />}
            {values.mobile_phone_formated && <LabelAndValue label={labelSetting.cellPhoneLabel} value={formatFormatedPhoneNumber(values.mobile_phone_formated)} />}
            {values.home_phone_formated && <LabelAndValue label={labelSetting.homePhoneLabel} value={formatFormatedPhoneNumber(values.home_phone_formated)} />}
        </>
    );
}

interface Props {
    values: MaritalStatusFormValues | DependentFormValues | GroupAdminAddFormValues | OfficerAddFormValues | PhoneFields;
    labelSetting: LabelSettingProps;
}
export function PhonesDisplay(props: Props) {
    const { values, labelSetting } = props;

    if (!values.business_phone_formated && !values.home_phone_formated && !values.mobile_phone_formated) return null;

    return (
        <>
            <ContentSpacer>
                <h3>{labelSetting.phoneSectionTitle}</h3>
            </ContentSpacer>
            <PhonesContentDisplay labelSetting={labelSetting} values={values} />
        </>
    );
}